import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AgTrendIndicatorParams } from '@shared/ag-components/ag-trend-indicator/ag-trend-indicator.model';
import { AuxIconName } from '@shared/components/icon/icon';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgClass, TooltipDirective],
  standalone: true,
  templateUrl: 'ag-trend-indicator.component.html',
})
export class AgTrendIndicatorComponent implements ICellRendererAngularComp {
  icon!: AuxIconName;
  iconColorClass!: string;
  params: AgTrendIndicatorParams | undefined;
  textColorClass!: string;

  agInit(params: AgTrendIndicatorParams): void {
    this.params = params;
    this.textColorClass = params.textColorClass || '';
    const variation = params.value || 0;

    let showUp = params.reverseArrow ? variation < 0 : variation > 0;
    let showDown = params.reverseArrow ? variation > 0 : variation < 0;

    if (showUp) {
      this.iconColorClass = params.oneColorIcons ? '' : 'text-aux-green-dark';
      this.icon = 'ArrowUp';
    } else if (showDown) {
      this.iconColorClass = params.oneColorIcons ? '' : 'text-aux-red-dark';
      this.icon = 'ArrowDown';
    }
  }

  refresh(): boolean {
    return false;
  }
}
